import { Activity } from 'sharebase/domain';

const template = require('./folderDetails.template');
require('./folderDetails.styles');

export interface FolderDetails {
	activities:Activity[];
	dateCreated:Date;
	dateModified:Date;
	owner:string;
	totalFiles: number;
};

export const DefaultFolderDetails: FolderDetails = {
	activities: [],
	dateCreated: new Date(0),
	dateModified: new Date(0),
	owner: '',
	totalFiles: 0
}

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaFolderDetails
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaFolderDetails` displays details of a document
 *
 * @usage
 *
 * <sba-document-details document-id="1234" /> 
 * 
 * @element input
 * 
 * @param {integer=} documentId The id of the document to display details for
 *  
 * @param {bool} detailsStoreResolved Has the data store for the details been resolved already
 */
export function FolderDetailsDirective(
	$timeout:ng.ITimeoutService, 
	$mdMedia, 
	localStorageService
):ng.IDirective {
	return {
		restrict: 'E',
		template,
		scope: true,
		controller: FolderDetailsController,
		controllerAs: 'vm',
		bindToController: {
			folderId: '@',
			detailsStoreResolved: '@'
		},
		link: (scope, element, attrs, vm: FolderDetailsController) => {
			//active tab
			scope.$watch('vm.activeDetailTab', function (newVal) {
				if (newVal === undefined || newVal === null) { return; }
				else {
					vm.localStorageService.setStoredValue('sba-folder-details-active-tab', newVal);
				}
			});

			scope.$on('$destroy', function() {
				vm.subs.forEach(function(sub) {
					sub();
				});
			});
		}
	}
}

FolderDetailsDirective.$inject = [
	'$timeout',
	'$mdMedia',
	'localStorageService'
];

export class FolderDetailsController {
	public static $inject = [
		'$q',
		'$http',
		'$timeout',
		'$mdMedia',
		'pxAuthService',
		'pxUploadService',
		'sbaFolderDataStore',
		'localStorageService',
		'gettextCatalog',
	];

	constructor(
		private $q:ng.IQService,
		private $http:ng.IHttpService,
		private $timeout:ng.ITimeoutService,
		private $mdMedia,
		private pxAuthService,
		private pxUploadService,
		public sbaFolderDataStore,
		public localStorageService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
		if (!this.folderId) { return; }
		
		if (!$mdMedia('gt-sm')) {
			//remembering the user detail state on a mobile UI doesn't seem to make sense
			this.activeDetailTab = 0;
		}

		this.loadDetails();

		this.uiLoading = true;
		this.you = this.gettextCatalog.getString('You');
		this.activeDetailTab = this.localStorageService.getStoredValue('sba-folder-details-active-tab') === '1' ? 1 : 0;
		this.activeSecondaryView = this.localStorageService.getStoredValue('sba-folder-details-second-view');
		this.loadingActivities = false;
		this.subs.push(this.pxUploadService.onComplete(() => this.reloadDetailsPanel()));
	}

	public folderId: number;
	public uiLoading = true;
	public you;
	public activeDetailTab;
	public activeSecondaryView;
	public loadingActivities;

	// subscriptions that need to be cleared when the component is destroyed
	public subs = [];

	public get details():FolderDetails {
		return this.sbaFolderDataStore.details;
	}	

	public loadDetails(): ng.IPromise<any> {
		if (!this.folderId) { return; }

		return this.sbaFolderDataStore
			.load(this.folderId)
			.then(() => this.sbaFolderDataStore.loadDetails())
			.then(() => {
				this.uiLoading = false;
			});
	}

	public loadActivities() {
		if (!this.folderId) { return; }

		let isSwitchingToActivitiesTab = this.activeDetailTab != this.localStorageService.getStoredValue('sba-doc-details-active-tab');
		let delay =  isSwitchingToActivitiesTab ? 600 : 0; //Default transition time + 100ms to allow tab animation to complete or 0 if already viewing Tab

		this.loadingActivities = true;
		this.$timeout(() => {
			this.sbaFolderDataStore.loadActivities(this.folderId)
				.then(activities => this.loadingActivities = false);
		}, delay);
	}

	private reloadDetailsPanel() {
		this.loadDetails()
			.then(() => {
				if(this.activeDetailTab === 1) {
					this.loadActivities();
				}
			})
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/folderDetails/folderDetails.ts